export default __webpack_public_path__ + "img/xcross-bold.e81b6ae8.svg";